import * as z from "zod";

export const editInfoSchema = z
  .object({
    username: z
      .string()
      .min(3, "Username must be 3-30 characters")
      .max(30, "Username must be 3-30 characters")
      .refine(
        (value) =>
          !value.includes("@") || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value),
        {
          message: "Username cannot be in email format",
        }
      ),
    email: z.string().email("Invalid email address"),
  })
  .refine((data) => data.username !== data.email, {
    path: ["email"],
    message: "Username and email must be different",
  });

export type EditInfoFormData = z.infer<typeof editInfoSchema>;
